









































import { defineComponent, computed } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';

export default defineComponent({
  name: 'SfProductCardSkeleton',
  components: {
    SkeletonLoader,
  },
  props: {
    cardStyle: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(props) {
    const isCompact = computed(() => props.cardStyle === 'compact');
    return {
      isCompact,
    };
  },
});
